import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import { Row, Item, Sup, Button, IconContainer } from './styles'
import { Order } from '../../components/Icons'

class OrderTableRow extends Component {

  render() {
    let {
      headers,
      item
    } = this.props

    return (
      <Row key={item.id} noPadding>
        <Item>
          <Sup>{headers[0]}</Sup>
          {typeof item.one === 'string' ? item.one : item.one}
        </Item>
        <Item>
          <Sup>{headers[1]}</Sup>
          {typeof item.two === 'string' ? item.two : item.two}
        </Item>
        {headers[2] ? (
          <Item>
            <Sup>{headers[2]}</Sup>
            {typeof item.three === 'string' ? item.three : item.three}
          </Item>
        ) : null}
        {headers[3] ? (
          <Item>
          <Sup>{headers[3]}</Sup>
          {typeof item.four === 'string' ? item.four : item.four} 
        </Item>
        ) : null}
        <Item>
          <Link to={`/orderhistorie/${item.id}`}>
            <Button>
              <IconContainer>
                <Order size="" />
              </IconContainer>
            </Button>
          </Link>
        </Item>
      </Row>
    )
  }
}

export default withRouter(OrderTableRow)



// WEBPACK FOOTER //
// ./src/components/OrderTableRow/index.js